import { defineComponent as _defineComponent } from 'vue'
import { loadStripe, Stripe, SetupIntent, PaymentIntent } from '@stripe/stripe-js'
import PaymentSelectWindow from './payment-select-window.vue'
import PaymentInputWindow from './payment-input-window.vue'
import { DataInstance, FinancialUserspaces, PaymentMethods } from '@busy-human/opt-library'
import { checkLoggedIn } from '../util/auth'
import { httpsCallable } from 'firebase/functions'
import {functions} from '../util/firebase'
import { onBeforeMount, onMounted, ref, computed } from 'vue';
import { CollectionEntityInterface, SubsetEntityInterface } from '@busy-human/gearbox'
import { CollectionReference, query, where } from 'firebase/firestore'
import { useBalance } from "@/util/balance";
import { useUserspace } from '@/store/userspace'

type Props = {
    payment?: string | null;
    withdraw?: boolean;
    price: number;
}
type Emits = {
    (e: 'update:payment', payment: string): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'payment-button',
  props: {
    payment: null,
    withdraw: { type: Boolean },
    price: null
  },
  emits: ["update:payment"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'update:payment', payment: string): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    payment?: string | null;
    withdraw?: boolean;
    price: number;
}





const userspace = useUserspace();

const stripe = ref<Stripe | null>(null);
const userFinancial = computed(() => userspace.financial);
const paymentMethods = ref<DataInstance<PaymentMethods.Model>[]>([])
const balances = useBalance();

onBeforeMount(async () => {
    if(userFinancial.value){
        let paymentMethodsRef
        if(props.withdraw) //TODO: Change .all() to the .where() equivolent
            paymentMethodsRef = (FinancialUserspaces.Collection.subCollectionEntity(userspace.uid, 'paymentmethods') as CollectionEntityInterface<PaymentMethods.Model>).subset(ref => query(ref, where("forPayouts", "==", true))) as SubsetEntityInterface<PaymentMethods.Model>
        else
            paymentMethodsRef = FinancialUserspaces.Collection.subCollectionEntity(userspace.uid, 'paymentmethods').all() as SubsetEntityInterface<PaymentMethods.Model>
        await paymentMethodsRef.fetch()
        paymentMethods.value = paymentMethodsRef.dataItems()

        if(props.payment){
            if(props.payment == 'useBalance'){
                selectedPayment.value = 'useBalance'
            }else{
                let paymentMethod = paymentMethods.value.filter((method) => {
                    return method.$id == props.payment
                })?.[0]

                selectedPayment.value = paymentMethod || null
            }
        }
    }
})

const selectedPayment = ref<DataInstance<PaymentMethods.Model> | string | null>(null)

onMounted(async () => {
    const stripePK = CONFIG.stripe.publishableKey;
    stripe.value = await loadStripe(stripePK)
})

const showPaymentSelect = ref(false)
const showPaymentInput = ref(false)

const selectPayment = () => {
    //If the user isn't logged in, we still want to create a Payment Method, but thats all they can really do
    if(checkLoggedIn())
        showPaymentSelect.value = true
    else{
        showPaymentInput.value = true
    }
}

const createPaymentInfo = async (newPayment: PaymentMethods.Model) => {
    if(checkLoggedIn()){
        const createPaymentMethods = httpsCallable<{paymentMethod: PaymentMethods.Model, uid?: string}, DataInstance<PaymentMethods.Model>>(functions, 'createPaymentMethods');
        try{
            const result = await createPaymentMethods({paymentMethod: newPayment, uid: useUserspace().uid});
            paymentMethods.value.push(result.data)
            selectInfo(result.data)
        }catch(e){
            console.error(e);
        }
    }
    showPaymentInput.value = false
}

const onUseBalance = () => {
    selectedPayment.value = 'useBalance'
    emit('update:payment', selectedPayment.value)
}

const selectInfo = (selectedMethod: DataInstance<PaymentMethods.Model>) => {
    selectedPayment.value = selectedMethod
    emit('update:payment', selectedPayment.value.$id)
}

const __returned__ = { props, emit, userspace, stripe, userFinancial, paymentMethods, balances, selectedPayment, showPaymentSelect, showPaymentInput, selectPayment, createPaymentInfo, onUseBalance, selectInfo, loadStripe, Stripe, SetupIntent, PaymentIntent, PaymentSelectWindow, PaymentInputWindow, DataInstance, FinancialUserspaces, PaymentMethods, checkLoggedIn, httpsCallable, functions, onBeforeMount, onMounted, ref, computed, CollectionEntityInterface, SubsetEntityInterface, CollectionReference, query, where, useBalance, useUserspace }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})